import axios from "../axios"
import {
    IPlatformCompanyGetCompanyData,
    IPlatformCompanyGetCompanyParams,
    IPlatformPortalData,
    IPlatformCompanySettingData,
    IPlatformCompanySettingParams,
    IPlatformCompanySettingSaveParams
} from "./platformCompany.types"

/**
 * 查询当前用户门户及登录入口
 */
export function platformPortal() {
    return axios<IPlatformPortalData>({
        method: 'get',
        url: '/platform/portal',
    })
}


/**
 * 查询子公司/总公司模板图片
 */
export function platformCompanyGetCompany(params: IPlatformCompanyGetCompanyParams) {
    return axios<IPlatformCompanyGetCompanyData>({
        method: 'get',
        url: "/platformCompany/setting/getCompany",
        params
    })
}



/**
 *  模板图片配置
 */
export function platformCompanyGetSetting(params: IPlatformCompanySettingParams) {
    return axios<IPlatformCompanySettingData>({
        method: 'get',
        url: '/platformCompany/setting/getPlatformCompany',
        params
    })
}

/**
 * 设置公司模板图片 
 */
export function platformCompanySettingSave(params: IPlatformCompanySettingSaveParams) {
    return axios({
        method: 'post',
        url: '/platformCompany/setting/save',
        data: params
    })
}
